export default "__VITE_ASSET__Ys6Z5W8Q__"